// extracted by mini-css-extract-plugin
export default {"details":"Seed_details__Xw1iA","badge":"Seed_badge__PtcOw"};